export default [
  {
    path: "/production-calendar",
    name: "production-calendar",
    meta: {
      title: "Производственный календарь",
      authRequired: true,
    },
    component: () => import("../views/index.vue"),
  },
];
